import { render, staticRenderFns } from "./UsefulVolumeChart.vue?vue&type=template&id=538a5582"
import script from "./UsefulVolumeChart.vue?vue&type=script&lang=js"
export * from "./UsefulVolumeChart.vue?vue&type=script&lang=js"
import style0 from "./UsefulVolumeChart.vue?vue&type=style&index=0&id=538a5582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports